import { Button } from "@common/index";
import styles from "./styles.module.scss";
import img from "./img/img.png";

export const GreatChoices = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <img src={img} alt="slimdown" className={styles.image} />
        <div className={styles.hints}>
          <h4>Great choices! We are almost done! </h4>
          <p className={styles.description}>
            Thank you for your remarkable honesty. Were nearly finished with the
            setup of your roadmap. Just a little more patience, my friend!
          </p>
        </div>
      </div>
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
